export enum ContactBalanceTableAccessor {
  AverageRange = 'averageRange',
  ContactName = 'contactName',
  LongRange = 'longRange',
  NotOverdue = 'notOverdue',
  ShortRange = 'shortRange',
  Total = 'total',
}
